import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataStorage } from './data/data-storage';
import { Breakpoint, fromMediaQuery, isAndroidDevice } from './helpers/utils';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    mobileVersion: boolean = false;
    persistentStorage: DataStorage = DataStorage.persistent();
    terminate = new Subject();
    refreshState = new Subject();

    constructor() {
        fromMediaQuery(Breakpoint.UpToMedium).subscribe(matches => this.mobileVersion = matches);
    }

    get isMobileVersion(): boolean {
        return this.mobileVersion;
    }

    get isAndroidDevice(): boolean {
        return isAndroidDevice();
    }

    get isAwaitingInitialSetup(): boolean {
        return this.persistentStorage.get('isAwaitingInitialSetup') || false;
    }

    clearAwaitingInitialSetup() {
        this.persistentStorage.remove('isAwaitingInitialSetup');
        this.refreshState.next(true);
    }
}
